/**
 * Контракт API рантайма шапки (`header-frontend`, `/v3/get-header-microfrontend/`).
 * Дублирует параметры метода `/v3/open-auth-modal/`.
 */

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IAuthModalViewData {
  headingType: string;
}

export interface IOpenAuthModalParameters {
  autoRefresh?: boolean;
  alert?: EAlertType | null;
  useDefaultView?: boolean;
  viewData?: IAuthModalViewData | null;
  source?: string | null;
}

export interface IHeaderMicrofrontendAPI {
  openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void>;
}

export interface IMicrofrontendsAPI {
  header: IHeaderMicrofrontendAPI;
}
